import { useCallback, useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseClient";
import { logError } from "../lib/logger";
import { formatDraftTimestamp } from "../lib/commandCenterDealDraft";
import { toTaskQueueLoadDisplayError } from "../lib/taskQueueLoadErrors";

const TASK_COLLECTION = "menu_gap_tasks";

export function sortMenuGapTasksByNewest(tasks) {
  return [...tasks].sort((a, b) => {
    const aMs = a.created_at?.toDate?.()?.getTime?.() || Date.parse(a.created_at) || 0;
    const bMs = b.created_at?.toDate?.()?.getTime?.() || Date.parse(b.created_at) || 0;
    return bMs - aMs;
  });
}

export function useMenuGapTasks(userId, enabled) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadTasks = useCallback(async () => {
    if (!enabled || !userId) {
      setTasks([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const q = query(
        collection(db, TASK_COLLECTION),
        where("source", "==", "command_center"),
        where("status", "==", "draft"),
        where("created_by_uid", "==", userId)
      );
      const snap = await getDocs(q);
      const items = snap.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));
      setTasks(sortMenuGapTasksByNewest(items));
    } catch (err) {
      logError("Failed to load menu gap tasks", err);
      setError(toTaskQueueLoadDisplayError(err, { context: "menu_gap_tasks" }));
      setTasks([]);
    } finally {
      setLoading(false);
    }
  }, [enabled, userId]);

  useEffect(() => {
    loadTasks();
  }, [loadTasks]);

  return { tasks, loading, error, reloadTasks: loadTasks, formatTaskTimestamp: formatDraftTimestamp };
}
